export class CacheItem {
  key: string;
  item: unknown;
}
